<template>
  <div>
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Customers</h3>
        <input type="text" v-model="searchValue" placeholder="Search Customer Name" id="search-input"> <br />
        <table class="Customer-table DisplayTable">
          <thead>
              <tr v-if="editingId != null">
                <th>Customer Id</th>
                <th>Customer Name</th>
                <th>Contact</th>
                <th>Charge To</th>
                <th class="buttonCol"/>
              </tr>
              <tr v-else>
                <th
                  v-if="currentSort == 'customerId'"
                  @click ="sort('customerId')"
                  :class="currentSortDir == 'asc' ? 'ReportsAscIcon' :'ReportsDescIcon'">
                  Customer Id
                </th>
                <th v-else
                  @click ="sort('customerId')"
                  class="ReportsDisabledIcon">
                  Customer Id
                </th>
                <th
                  v-if="currentSort == 'name'"
                  @click ="sort('name')"
                  :class="currentSortDir == 'asc' ? 'ReportsAscIcon' :'ReportsDescIcon'">
                  Customer Name
                </th>
                <th v-else
                  @click ="sort('name')"
                  class="ReportsDisabledIcon">
                  Customer Name
                </th>
                <th>Contact</th>
                <th
                  v-if="currentSort == 'chargeTo'"
                  @click ="sort('chargeTo')"
                  :class="currentSortDir == 'asc' ? 'ReportsAscIcon' :'ReportsDescIcon'">
                  Charge To
                </th>
                <th
                  v-else
                  @click ="sort('chargeTo')"
                  class="ReportsDisabledIcon">
                  Charge To
                </th>

                <th class="buttonCol" />
              </tr>
            </thead>
            <tbody>
            <tr height="30px">
              <td class="Customer-table-cell">
                <input type="text" v-model="customerId" placeholder="Customer Id"  class="CustomerName" @change="checkDuplicate(customerId.toUpperCase(), 'new')">
              </td>
              <td class="Customer-table-cell">
                <input type="text" v-model="name" placeholder="Customer Name" class="CustomerName" @change="allDataEntered(customerId, name, contactName, 'new')">
              </td>
              <td class="Customer-table-cell">
                <input type="text" v-model="contactName" placeholder="Contact" class="CustomerName" @change="allDataEntered(customerId, name, contactName, 'new')">
              </td>
              <td class="Customer-table-cell">
                <select v-model="chargeTo" class="CustomerName chargeTo" >
                  <option value="" disabled hidden>Select if charged to another customer</option>
                  <option
                    v-for="Customer in sortedChargeTo"
                    v-bind:value="Customer.name"
                    v-bind:key="Customer.customerId"
                    >
                    {{Customer.name}}
                  </option>
                </select>
              </td>
              <td v-if="editingId != null" class="Customer-table-cell">
                <button class="addrecordbutton icon btnDisabled" hidden></button>
              </td>
              <td v-else-if="CustValid && AllData && editingId === null" class="Customer-table-cell">
                <button v-on:click="createCustomer(id, customerId,name, contactName, chargeTo)"  class="addrecordbutton icon" title="Add Customer"></button>
              </td>
              <td v-else class="Customer-table-cell">
                <button  class="addrecordbutton icon btnDisabled" title="Not all data has been entered to add record" disabled></button>
              </td>
            </tr>
            <tr v-for= "(Customer, indexCustomer) in sortedCustomers" :key="indexCustomer" height="30px" data-is-editable="0">
                <td class="Customer-table-cell" >
                  <input type="text"
                    v-model="Customer.customerId"
                    :readonly="editingId == indexCustomer ? false : true"
                    :class="editingId == indexCustomer ? 'CustomerName editable' :'CustomerName'"
                    @change="checkDuplicate(Customer.customerId.toUpperCase(), 'update')">
                </td>
                <td class="Customer-table-cell">
                  <input type="text"
                    v-model="Customer.name"
                    :readonly="editingId == indexCustomer ? false : true"
                    :class="editingId == indexCustomer ? 'CustomerName editable' :'CustomerName'"
                    @change="allDataEntered(Customer.customerId, Customer.name, Customer.contactName, 'update')">
                </td>
                <td class="Customer-table-cell">
                  <input type="text"
                    v-model="Customer.contactName"
                    :readonly="editingId == indexCustomer ? false : true"
                    :class="editingId == indexCustomer ? 'CustomerName editable' :'CustomerName'"
                    @change="allDataEntered(Customer.customerId, Customer.name, Customer.contactName, 'update')">
                </td>
                <td class="Customer-table-cell">
                  <select v-model="Customer.chargeTo"
                      :disabled="editingId == indexCustomer ? false : true"
                      :class="editingId == indexCustomer ? 'CustomerName chargeTo editable' :'CustomerName chargeTo'"
                      >
                      <option v-for="Customer in sortedChargeTo"
                      v-bind:value="Customer.name"
                      v-bind:key="Customer.customerId"
                      >
                      {{Customer.name}}
                    </option>
                  </select>
               </td>

                <td class="Customer-table-cell">
                  <span  v-if="editingId === null">
                    <button v-on:click="editItem(indexCustomer)" class="editbutton icon" title="Edit Customer"></button>
                    <button v-on:click="deleteCustomer(Customer.id, Customer.name, Customer.chargeTo, indexCustomer)" class="deletebutton icon" title="Delete Customer"></button>
                  </span>
                  <span v-else-if="editingId === indexCustomer">
                    <span v-if="!CustValid || !AllData">
                      <button class="savebutton icon btnDisabled" title="Not all data has been entered to save record" disabled></button>
                    </span>
                    <span v-else>
                      <button v-on:click="updateCustomer(Customer.id, Customer.customerId.toUpperCase(), Customer.name, Customer.contactName, Customer.chargeTo)" class="savebutton icon" title="Save"></button>
                    </span>
                    <button v-on:click="canceledit()" class="cancelbutton icon" title="Cancel"></button>
                  </span>
                  <span v-else>
                    <button class="editbutton icon btnDisabled" hidden></button>
                    <button class="deletebutton icon btnDisabled" hidden></button>
                  </span>                 
               </td>

              </tr>
            </tbody>
        </table>
      </div>

      <div v-if="message" class="errormessage">
        <table>
          <tr>
            <td>{{message}}</td>
          </tr>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { listCustomers } from '../graphql/queries';
import { listContracts } from '../graphql/queries';
import { listVaccinations } from '../graphql/queries';
import { getCustomerById } from '../graphql/queries';
import { createCustomer } from '../graphql/mutations';
import { updateCustomer } from '../graphql/mutations';
import { deleteCustomer } from '../graphql/mutations';
import { onCreateCustomer } from '../graphql/subscriptions';
import { updateVaccination} from '../graphql/mutations';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";

export default {
  name: 'app',
  components:{
    RwvMenu,

  },
  async created() {
  // console.log('created ...')
    this.getCustomers();
    this.subscribeCreate();
    },
    data() {
      return {
        Customers: [],
        editingId: null,
        customerId: '',
        name: '',
        contactName:'',
        chargeTo: '',
        oldChargeTo: '',
        oldName: '',
        id:'',
        message: '',
        Duplicate: [],
        dupCode: '',
        ChargeTo: [],
        Contracts: [],
        UpdateCustomers: [],
        AllData: false,
        CustValid: false,
        currentSort: 'customerId',
        currentSortDir: 'asc',
        searchValue: '',
        frozenCustomers: [],
        Vaccinations: [],
      }
  },
  computed: {
    sortedCustomers: function() {
      // console.log('sortedCustomers ...');
      if(this.editingId != null) {return this.frozenCustomers}
      return this.searchCustomers.slice().sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] === null | a[this.currentSort] === undefined) return 1 * modifier;
        if(b[this.currentSort] === null | b[this.currentSort] === undefined) return -1 * modifier;
        if (this.currentSort === "name" || this.currentSort === "chargeTo") {            //sort case insensitive for name
          if(a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
          if(a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return 1 * modifier;
          return 0;
        }
        else {
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        }
      });
    },
    sortedChargeTo: function() {
//      console.log('sortedChargeTo ...');
      return this.Customers.slice().sort((a,b) => {
        if(a.name === null | a.name === undefined) return 1;
        if(b.name === null | b.name === undefined) return -1;
        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      });
    },
    searchCustomers() {
      let tempCustomers = this.Customers
      
      if (this.searchValue != '' && this.searchValue) {
            tempCustomers = tempCustomers.filter((item) => {
              return item.name
                .toUpperCase()
                .includes(this.searchValue.toUpperCase())
            })
          }
      return tempCustomers
      }
  },
  watch: {
    sortedCustomers: {
      handler: function() {
        if (this.editingId === null) {
          this.frozenCustomers = this.sortedCustomers.slice()
        }
      }     
    }
  },
  methods: {
    reset(){
//      Object.assign(this.$data, this.$options.data.apply(this));
      this.getCustomers();
    },
    async getCustomers() {
      // console.log("getCustomers ...");
      var limit = 2000;
      const Customers = await API.graphql({
        query: listCustomers,
        variables: {limit: limit}
      });
      this.Customers = Customers.data.listCustomers.items;
      // console.log('getCustomers end ...')
    },
                                                                // Create Customer
    async createCustomer(id, custId, nme, contactNme, chargeTo) {
      // console.log('createCustomer ...');
      if (!custId || !nme || !contactNme) return;
      if (!commonFunctions.xssTest(custId)) {
        this.message = commonFunctions.xssMessage("Customer Id")
        return
      }
      if (!commonFunctions.xssTest(nme)) {
        this.message = commonFunctions.xssMessage("Customer Name")
        return
      }
      if (!commonFunctions.xssTest(contactNme)) {
        this.message = commonFunctions.xssMessage("Contact")
        return
      }
      try {
        let customerId = custId.trim();
        let name = nme.trim();
        let contactName = contactNme.trim();
        if (chargeTo === "") {chargeTo = name;}
        const CreateValues = { customerId, name, contactName, chargeTo };
        await API.graphql({
          query: createCustomer,
          variables: {input: CreateValues},
        });
        this.resetVariables()
      }
      catch (error) {
        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('createCustomers end ...');
    },
                                                                // Update view on create
    subscribeCreate () {
      API.graphql({
        query: onCreateCustomer
        })
        .subscribe ({
          next: (items) => {
          const customer = items.value.data.onCreateCustomer;
          if (this.Customers.some(item => item.name === customer.id)) return; // remove duplications
          this.Customers = [...this.Customers, customer];
        }
        })
      },
                                                                // Check for duplicates
      async checkDuplicate(customerId,Updatetype) {
        // console.log('checkDuplicate ...');
        this.message = ''
        if (!commonFunctions.xssTest(customerId)) {
          this.message = commonFunctions.xssMessage("Customer Id")
          return
        }
        try {
          if(customerId != ''){
            this.CustValid = true;
            if (Updatetype === "new"){this.customerId = customerId.toUpperCase()}
            if (Updatetype != "new" && this.Customers[this.editingId].customerId === this.dupCode){
              return
            }
            const QueryVariables = {customerId};
            const RecordToTest = await API.graphql({
              query: getCustomerById,
              variables: QueryVariables,
            });
            this.Duplicate = RecordToTest.data.getCustomerById.items;
            if (this.Duplicate[0]){
              this.message = "Duplicate Customer Id entered";
              this.CustValid = false;
              return;
            }
          }
          else{this.CustValid = false;}
        }
        catch (error) {
          console.log(error)
          this.message = commonFunctions.displayError(error);
        }
        // console.log('checkDuplicate end');
      },

    allDataEntered(customerId, name, contactName){
      //  console.log ("allDataEntered ...");
        this.message = '';
        if (this.editingId && this.oldChargeTo == this.oldName && this.oldName != name){
          this.sortedCustomers[this.editingId].chargeTo = name.trim();
        }
        if (!customerId || !name || !contactName){
          this.AllData = false;
          return
        }
        if (!commonFunctions.xssTest(customerId)) {
          this.message = commonFunctions.xssMessage("Customer Id")
          this.AllData = false;
          return
        }
        if (!commonFunctions.xssTest(name)) {
          this.message = commonFunctions.xssMessage("Customer Name")
          this.AllData = false;
          return
        }
        if (!commonFunctions.xssTest(contactName)) {
          this.message = commonFunctions.xssMessage("Contact")
          this.AllData = false;
          return
        }
        this.AllData = true;
        // console.log ("allDataEntered end");
      },
                                                              // Update Customer
    async updateCustomer(id, custId, nme, contactNme, chargeTo) {
      // console.log('updateCustomer ...')
      if (!custId || !nme || !contactNme) return;
      if (!commonFunctions.xssTest(custId)) {
        this.message = commonFunctions.xssMessage("Customer Id")
        return
      }
      if (!commonFunctions.xssTest(nme)) {
        this.message = commonFunctions.xssMessage("Customer Name")
        return
      }
      if (!commonFunctions.xssTest(contactNme)) {
        this.message = commonFunctions.xssMessage("Contact")
        return
      }
      try {
        let customerId = custId.trim();
        let name = nme.trim();
        let contactName = contactNme.trim();
        const UpdateValues = { id, customerId, name, contactName, chargeTo };
        await API.graphql({
          query: updateCustomer,
          variables: {input: UpdateValues},
        });
        if(name != this.oldName){
          this.UpdateOtherCustomers(this.oldName, name)
        }
        if (chargeTo != this.oldChargeTo){
          this.updateVaccinations(id, chargeTo)
        }
        this.editingId = null;
//        this.$forceUpdate();
      }
      catch (error) {
        console.log(error)
        this.message = commonFunctions.displayError(error);
    }
      // console.log('updateCustomer end ...');
    },
                                                                // Delete Customer
    async deleteCustomer(id, custName, chrgeTo, indexRow) {
      // console.log('deleteCustomer ...');
      this.message = ""
      if(confirm("Do you really want to delete Customer (" + custName +")?")) {
                                                                    // check if any other customers charged to this customer
        try {
          var filter;
          filter = {
            and: {
              chargeTo: {eq: custName},
              name: {ne: chrgeTo}
            }
          }
          const ChargeTo = await API.graphql({
            query: listCustomers,
            variables: {filter: filter}
            });
          this.ChargeTo = ChargeTo.data.listCustomers.items;
          if (this.ChargeTo[0]){
          this.message = "Other customers are charged to this customer. It cant be deleted";
          return;
          }
                                                                    // check if any contracts for this customer
          filter ={
            customerId: {eq: id}
          }
          const Contracts = await API.graphql({
            query: listContracts,
            variables: {filter: filter}
          });
          this.Contracts = Contracts.data.listContracts.items;
          if (this.Contracts[0]){
          this.message = "Contracts exist for this customer. It cant be deleted";
          return;
          }
          const Customer = {id};
          await API.graphql({
            query: deleteCustomer,
            variables: {input: Customer},
          });
          this.sortedCustomers.splice(indexRow, 1);
        }
        catch (error) {
          console.log(error)
          this.message = commonFunctions.displayError(error);
        }
        this.$forceUpdate();
      }
      // console.log('deleteCustomer end ...');
    },
                                                              // Update existing customers when chargeto changed
    async UpdateOtherCustomers(oldName, name) {
//      console.log('UpdateOtherCustomers ...')
        var filter;
        var limit = 2000;
        filter ={
          chargeTo: {eq: oldName}
        }
        try {
          const UpdateCustomers = await API.graphql({
            query: listCustomers,
            variables: {filter: filter, limit: limit}
          });
          this.UpdateCustomers = UpdateCustomers.data.listCustomers.items;
          var i;
          var id;
          var chargeTo = name;
          for (i=0; i<this.UpdateCustomers.length; i++){
            id = this.UpdateCustomers[i].id;
            const UpdateValues = { id, chargeTo };
            await API.graphql({
              query: updateCustomer,
              variables: {input: UpdateValues},
            });
            this.updateVaccinations(this.UpdateCustomers[i].id, chargeTo);
          }

        }
        catch (error) {
          this.message = commonFunctions.displayError(error);
        }
        this.reset();
//      console.log('UpdateOtherCustomers end')
    },                                                              // Update existing vaccinations when chargeto changed
    async updateVaccinations(custId, chargeTo) {
//      console.log('updateVaccinations ...')
        var filter;
        var limit = 2000;
        filter ={
          customerId: {eq: custId}
        }
        try {
          const Contracts = await API.graphql({
            query: listContracts,
            variables: {filter: filter, limit: limit}
          });
          this.Contracts = Contracts.data.listContracts.items;
          var c = 0;
          var nextToken;
          for (c; c<this.Contracts.length; c++){
            filter = {
              voucherCode: {eq: this.Contracts[c].voucherCode}
            }
            const Vaccinations = await API.graphql({
              query: listVaccinations,
              variables: {filter: filter}
            });
            this.Vaccinations = Vaccinations.data.listVaccinations.items;
            nextToken = Vaccinations.data.listVaccinations.nextToken;

            while (nextToken){
              const VaccinationLoop = await API.graphql({
                query: listVaccinations,
                variables: {filter: filter, limit: limit, nextToken: nextToken}
              });
              this.Vaccinations = this.Vaccinations.concat(VaccinationLoop.data.listVaccinations.items);
              nextToken = VaccinationLoop.data.listVaccinations.nextToken;        
            }
 
            var id;
            var v;
            for (v = 0; v < this.Vaccinations.length; v++) {
              id = this.Vaccinations[v].id;
              var UpdateValues = {id, chargeTo};
              API.graphql({
                query: updateVaccination,
                variables: {input: UpdateValues},
              });
            }
          }
        }
        catch (error) {
          this.message = commonFunctions.displayError(error);
        }
//      console.log('updateVaccinations end')
    },
                                                              // set row in edit mode
    editItem(indexRow) {
      // console.log('editItem ...')
      this.editingId = indexRow;
      this.resetVariables();
      this.dupCode = this.sortedCustomers[this.editingId].customerId;
      this.oldChargeTo = this.sortedCustomers[this.editingId].chargeTo;
      this.oldName = this.sortedCustomers[this.editingId].name;
      this.AllData = true;
      this.CustValid = true;
    },
                                                                  // Reset row to original values
    canceledit() {
        // console.log('Cancel Edit ...')
        this.editingId = null;
        this.resetVariables();
        this.reset();
      },
    resetVariables() {
      this.customerId = '';
      this.name = '';
      this.contactName = '';
      this.chargeTo = '';
      this.oldChargeTo = '';
      this.CustValid = false;
      this.AllData = false;
      this.message = '';
      this.Contracts = [];
    },
    sort: function(s) {
      // console.log('sort ...');
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
      // console.log('sort end');
    },
  }
}
</script>
<style>

</style>
